/**
 * The free-text fields of a §302 Nutzdatendatei that come out of somebody's typing
 * (#1954).
 *
 * ⚠ **The fields the text clean-up runs over, and no others.** Every value here
 * stands for one component of `NAD`, `ZHE`, `DIA` or `NAM` that a practice can paste
 * anything into. A field the files fill from a catalogue or a number never reaches the
 * clean-up, and the two identifiers among the text fields — `NAD.Vers.-PLZ` and
 * `NAM.Name 4` (the e-mail address) — are not on the list either: they go out whole
 * or not at all, so a character they cannot carry drops the value instead of blocking
 * the run.
 *
 * ⚠ **An API contract, not a label.** The value travels in the run's refusal list
 * (`CHARACTER_NOT_REPRESENTABLE`); the German name of the field stands in the
 * frontend.
 */
export var GkvTextField;
(function (GkvTextField) {
    /** `NAD.Vers.-Nachname`. */
    GkvTextField["INSURED_LAST_NAME"] = "INSURED_LAST_NAME";
    /** `NAD.Vers.-Vorname`. */
    GkvTextField["INSURED_FIRST_NAME"] = "INSURED_FIRST_NAME";
    /** `NAD.Vers.-Straße/Nr.`. */
    GkvTextField["INSURED_STREET"] = "INSURED_STREET";
    /** `NAD.Vers.-Wohnort`. */
    GkvTextField["INSURED_CITY"] = "INSURED_CITY";
    /** `ZHE.Patientenindividuelle Leitsymptomatik`. */
    GkvTextField["PATIENT_SPECIFIC_SYMPTOMS"] = "PATIENT_SPECIFIC_SYMPTOMS";
    /** `DIA.Diagnoseschlüssel` of the first ICD row of Muster 13. */
    GkvTextField["FIRST_DIAGNOSIS_CODE"] = "FIRST_DIAGNOSIS_CODE";
    /** `DIA.Diagnosetext` of the first ICD row of Muster 13. */
    GkvTextField["FIRST_DIAGNOSIS_TEXT"] = "FIRST_DIAGNOSIS_TEXT";
    /** `DIA.Diagnoseschlüssel` of the second ICD row. */
    GkvTextField["SECOND_DIAGNOSIS_CODE"] = "SECOND_DIAGNOSIS_CODE";
    /** `DIA.Diagnosetext` of the second ICD row. */
    GkvTextField["SECOND_DIAGNOSIS_TEXT"] = "SECOND_DIAGNOSIS_TEXT";
    /**
     * `NAM.Name 1` — the name of the location that bills.
     *
     * ⚠ **A field of the location, not of a case.** Every case of the run carries the
     * same value, so a refusal of it names no case.
     */
    GkvTextField["BILLING_PARTY_NAME"] = "BILLING_PARTY_NAME";
    /** `NAM.Name 3` — the location's telephone number. A field of the location, too. */
    GkvTextField["BILLING_PARTY_PHONE"] = "BILLING_PARTY_PHONE";
})(GkvTextField || (GkvTextField = {}));
/** The fields every case of one location shares — `NAM` is written per location. */
export const GKV_LOCATION_TEXT_FIELDS = [
    GkvTextField.BILLING_PARTY_NAME,
    GkvTextField.BILLING_PARTY_PHONE,
];
//# sourceMappingURL=gkv-text-field.enum.js.map